import InsuranceNavItem from './InsuranceNavItem';

export default InsuranceNavItem;
